import React, { useState } from 'react'

interface Details {
  description?: string
  ingredients?: string
  other_product_info?: []
}

const ProductInfoSections: React.FC<{ details?: Details }> = ({ details }) => {
  const [showMoreDesc, setShowMoreDesc] = useState(false)
  const [showMoreIng, setShowMoreIng] = useState(false)
  const description = details?.description ?? ''
  const isLongDesc = description.length > 220

  const trunc = (txt: string, n = 220): string => (txt.length > n ? `${txt.slice(0, n)}…` : txt)

  return (
    <div className="w-full max-w-4xl text-gray-800 lg:px-4">
      {/* Highlights */}
      {/* {details.other_product_info !== null && Object.keys(details.other_product_info).length > 0 && (
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-3">Highlights</h2>
          <div className="overflow-hidden rounded-xl border">
            {Object.entries(details.other_product_info).map(([key, value]) => (
              <div key={key} className="grid grid-cols-2 gap-4 border-b px-4 py-3 last:border-b-0">
                <span className="text-gray-500">{key}</span>
                <span className="font-medium">{value}</span>
              </div>
            ))}
          </div>
        </div>
      )} */}

      {/* Product Details */}
      {(details?.description !== '' && details?.description !== null) && (
        <div className="py-5">
          <div className="flex items-center justify-between">
            <h3 className="text-base md:text-base font-bold">Product Details</h3>
          </div>
          <p className="mt-2 text-[13px] md:text-base leading-relaxed">
            {showMoreDesc ? description : trunc(description)}
          </p>
          {isLongDesc && (
              <button
                  type="button"
                  onClick={() => { setShowMoreDesc(s => !s) }}
                  className="mt-2 text-[13px] font-bold text-[#B8238E]"
              >
                {showMoreDesc ? 'Show less -' : 'Show more +'}
              </button>
          )}
        </div>
      )}

      {/* Ingredients */}
      {details?.ingredients !== '' && (
        <div className="py-5">
          <div className="flex items-center justify-between">
            <h3 className="text-base md:text-lg font-semibold">Ingredients</h3>
          </div>
          <p className="mt-2 text-sm md:text-base leading-relaxed">
            {showMoreIng ? details?.ingredients : trunc(details?.ingredients ?? '')}
          </p>
          <button
            type="button"
            onClick={() => { setShowMoreIng(s => !s) }}
            className="mt-2 text-sm font-medium text-[#B8238E]"
          >
            {showMoreIng ? 'Show less -' : 'Show more +'}
          </button>
        </div>
      )}
    </div>
  )
}

export default ProductInfoSections
